import React from 'react';

class BaseComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getDefaultState();
  }

  getDefaultState() {
    return {}
  }
}

class DismissComponent extends BaseComponent {
  /*
    Ensure you add this to div's you don't want to dismiss from
      onMouseDown={this.mouseDownHandler.bind(this)}
      onMouseUp={this.mouseUpHandler.bind(this)}
  */

  constructor(props) {
    super(props);

    this.mouseIsDown = false;
    window.addEventListener("mousedown", this.pageClick.bind(this), false);
  }

  pageClick() {
    if (this.mouseIsDown) {
      return;
    }

    this.setState({
      toggled: false
     });
  }

  mouseDownHandler() {
    this.mouseIsDown = true;
  }

  mouseUpHandler() {
    this.mouseIsDown = false;
  }
}

class FilteredComponent extends BaseComponent {
  getDefaultState() {
    return {
      "filters": {}
    }
  }

  componentWillMount() {
    radio("filterChanged").subscribe(this.filterChanged.bind(this));
    radio("filtersFinishedInitialized")
      .subscribe(this.filtersFinishedInitialized.bind(this));
    radio("searchClicked").subscribe(this.searchClicked.bind(this));
  }

  filterChanged(filterKey, serializedFilter) {
    var newFilters = this.state.filters;
    newFilters[filterKey] = serializedFilter;
    this.setState({
      "filters": newFilters
    });

    this.handleFiltersChanged(newFilters, this.state.searchString);
    this.updateURL(newFilters);
  }

  searchClicked(searchString) {
    this.setState({
      searchString: searchString
    });

    this.handleFiltersChanged(this.state.filters, searchString)
  }

  updateURL(filters) {
    var uri = URI(window.location);
    var parameter = {"filters": this.getFilterParameterString(filters, false)};
    uri.setSearch(parameter);
    if (history.replaceState) {
      history.replaceState(parameter, document.title, uri.toString());
    }
  }

  filtersFinishedInitialized(filters) {
    this.setState({
      "filters": filters
    });

    this.handleFiltersChanged(filters, this.state.searchString);
    this.updateURL(filters);
  }

  getFilterParameterString(filters, doEncoding) {
    var string = "";
    if (filters) {
      string = JSON.stringify(filters);
    } else if (this.state.filters) {
      string = JSON.stringify(this.state.filters);

    }

    if (doEncoding) {
      string = encodeURIComponent(string);
    }

    return string;
  }

  getSearchParameterstring(searchString) {
    var string = "";
    if (searchString) {
      string = "&search=" + encodeURIComponent(searchString)
    } else if (this.state.searchString) {
      string = "&search=" + encodeURIComponent(this.state.searchString)
    }

    return string
  }

  getStartDate() {
    if (this.state.filters &&
      this.state.filters.created &&
      this.state.filters.created.length > 1) {
      return encodeURIComponent(this.state.filters.created[0]);
    }
    return "";
  }

  getEndDate() {
    if (this.state.filters &&
      this.state.filters.created &&
      this.state.filters.created.length > 1) {
      return encodeURIComponent(this.state.filters.created[1]);
    }
    return "";
  }

  /* Override this method if you want somekind of
  callback when filters change */
  handleFiltersChanged() {
  }
}

module.exports = {
  BaseComponent: BaseComponent,
  DismissComponent: DismissComponent,
  FilteredComponent: FilteredComponent
}
